import { getStateSourceElement } from "utils";

export const StateSource = ({
  type,
  onErrorClick,
}: {
  type: "DONE" | "ERROR" | "ENQUEUED";
  onErrorClick: () => void;
}) => {
  return getStateSourceElement(type, onErrorClick);
};
